import {
  faArrowUp,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faMicrophone,
  faMicrophoneSlash,
  faStar,
  faStop,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons'
import {
  faClock as farClock,
  faKeyboard as farKeyboard,
  faPen as farPen,
  faStar as farStar,
} from '@fortawesome/pro-regular-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'

export type TIconName = `fa-${IconName}`
export type TIcon = TIconName | `${IconPrefix} ${TIconName}`

library.add(
  faArrowUp,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faMicrophone,
  faMicrophoneSlash,
  faStar,
  faStop,
  faXmark,
  farClock,
  farKeyboard,
  farPen,
  farStar
)
